import CreateArea from "./CreateArea";

export default CreateArea;
